import { render, staticRenderFns } from "./ProjectDocumentTemplateEdit.vue?vue&type=template&id=a56e99aa&"
import script from "./ProjectDocumentTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports